enum TechnologyName {
  TYPESCRIPT = 'typescript',
  REACT = 'react',
  REDUX = 'redux',
  NODEJS = 'nodejs',
  POSTGRESQL = 'postgresql',
  FASTIFY = 'fastify',
  SOCKET_IO = 'socketio',
  OPEN_AI = 'open-ai',
  AWS = 'aws',
  STRIPE = 'stripe',
  PRISMA = 'prisma',
  REDIS = 'redis',
  DOT_NET = 'dotnet',
  ANGULAR = 'angular',
  MS_SQL = 'mssql',
  DOCKER = 'docker',
  SIGNAL_R = 'signalr',
  RABBIT_MQ = 'rabbitmq',
  AZURE = 'azure',
  FLUTTER = 'flutter',
  NEXT_JS = 'nextjs',
}

export { TechnologyName };
